import { colorPalette } from '@lgg/isomorphic';

export const cardsTheme = {
  default: `
    border-radius: 6px;
    box-shadow: 0 2px 80px 0 #2526310d;
    background-color: ${colorPalette.white};
  `,
};
